import React, { useEffect, useState } from "react";
import axios from "axios";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading/Loading";

function Addcheckin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [title, setTitle] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [add, setAdd] = useState({
    name: "",
    in: "",
    out: false,
    mode: "",
    notes: "",
  });

  const addGuest = async () => {
    if (
      add.name !== "" &&
      add.in !== "" &&
      add.mode !== "" &&
      add.notes !== ""
    ) {
      setLoading(true);
      await axios.post("https://mobile.amospa.com/checkin", add);
      setLoading(false);
      setTitle("Success Add Guest");
      setModalShow(true);
    } else {
      setTitle("fill in all forms");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/members/chekin/");
  };

  useEffect(() => {}, [modalShow]);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-user">
                <div className="wrapper-edit-image">
                  <div className="header-edit-image">
                    <h5 className="m-0">Create New Guest</h5>
                  </div>
                  <div className="data-user">
                    <div className="wrapper-data">
                      <label>
                        Guest Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        onChange={(e) =>
                          setAdd({ ...add, name: e.target.value })
                        }
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>
                        Checkin <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        name="in"
                        onChange={(e) => setAdd({ ...add, in: e.target.value })}
                      />
                    </div>

                    <div className="wrapper-data">
                      <label>
                        Mode <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="mode"
                        onChange={(e) =>
                          setAdd({ ...add, mode: e.target.value })
                        }
                      />
                    </div>

                    <div className="wrapper-data">
                      <label>
                        Note <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="notes"
                        onChange={(e) =>
                          setAdd({ ...add, notes: e.target.value })
                        }
                      />
                    </div>
                    <button onClick={() => addGuest()}>Create New Guest</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" ? handleNext : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Addcheckin;
